import { useRef } from "react";

function useSwipeWeek(calendarRef) {
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    if (
      touchStartX.current === null ||
      touchStartY.current === null
    ) {
      return;
    }

    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;

    const deltaX = touchEndX - touchStartX.current;
    const deltaY = touchEndY - touchStartY.current;

    const minimumSwipe = 50;

    // Ignore vertical swipes
    if (
      Math.abs(deltaX) < minimumSwipe ||
      Math.abs(deltaX) < Math.abs(deltaY)
    ) {
      return;
    }

    if (deltaX < 0) {
      // Swipe left → next week
      calendarRef.current
        .getApi()
        .next();
    } else {
      // Swipe right → previous week
      calendarRef.current
        .getApi()
        .prev();
    }

    touchStartX.current = null;
    touchStartY.current = null;
  };

  return {
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
  };
}

export default useSwipeWeek;